import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-lg-12 col-md-12" }
const _hoisted_2 = { class: "listing-item-container list-layout" }
const _hoisted_3 = {
  href: "listings-single-page.html",
  class: "listing-item"
}
const _hoisted_4 = { class: "listing-item-image" }
const _hoisted_5 = { class: "listing-item-content" }
const _hoisted_6 = { class: "listing-item-inner" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "like-icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("a", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.place?.images[0].name,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("h3", null, _toDisplayString(_ctx.place?.name), 1),
            _createVNode("span", null, _toDisplayString(_ctx.place?.address?.addressLine1) + ", " + _toDisplayString(_ctx.place?.address?.city), 1)
          ]),
          _hoisted_7
        ])
      ])
    ])
  ]))
}